
<div class="popover-links popover-links--aligned" #content>
  <div
      class="body-1 d-flex align-items-center cursor-pointer px-4 py-1"
      (click)="resend($event)"
      style="line-height: 24px !important;"
  >
      <i class="black-text fas fa-rotate-right mt-0 mr-2"></i>
      <div class="text-nowrap">Resend</div>
  </div>  
</div>
